/**
 * DateCell — инлайн-редактирование плановой даты через DatePicker. Автосохранение по выбору даты
 * (PATCH plannedDate). Read-only режим (locked/нет прав) отдаёт просто текст dd.MM.yyyy.
 */

import { useState } from 'react';
import { fmtDate } from './lib/dates';
import { DatePicker } from './ui/DatePicker';
import { cx } from './ui/cx';

export interface DateCellProps {
  value: string | null;
  editable: boolean;
  onChange: (ymd: string) => void;
  ariaLabel?: string;
  /** Приглушить пустое значение (для факт-даты). */
  mutedWhenEmpty?: boolean;
}

export function DateCell({ value, editable, onChange, ariaLabel, mutedWhenEmpty }: DateCellProps): JSX.Element {
  const [open, setOpen] = useState(false);

  if (!editable) {
    return <span className={cx('pw-num', mutedWhenEmpty && !value && 'pw-muted')}>{fmtDate(value)}</span>;
  }

  return (
    <DatePicker
      value={value}
      open={open}
      onOpenChange={setOpen}
      onSelect={(ymd) => {
        if (ymd && ymd !== value) onChange(ymd);
      }}
      trigger={
        <button type="button" className="pw-cell-edit pw-num" title="Изменить дату" aria-label={ariaLabel ?? 'Изменить дату'}>
          {fmtDate(value)}
        </button>
      }
    />
  );
}
